import { compose } from 'recompose';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import L from 'leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { useLeaflet } from 'react-leaflet';

L.PolylineClusterable = L.Polyline.extend({
  _originalInitialize: L.Polyline.prototype.initialize,

  initialize: function (latlngs, options) {
    this._originalInitialize(latlngs, options);
    this._latlng = this.getBounds().getCenter();
  },

  getLatLng: function () {
    return this._latlng;
  },

  setLatLng: function () {},
});

/// Marker cluster for Stops on a Template on the Template-Stop-Overview -> Templates
const TemplateStopTemplateMarkerCluster = (props) => {
  const {
    templateStops,
    polyline,
    template,
    t,
    getClusterIcon,
    getTemplateStopMarkerAndAddToMcg,
    useCluster,
  } = props;

  const mcg = L.markerClusterGroup({
    iconCreateFunction: function () {
      return getClusterIcon(template);
    },
    maxClusterRadius: 1000,
    showCoverageOnHover: false,
    disableClusteringAtZoom: useCluster ? 14 : 1,
    spiderfyOnMaxZoom: false,
  });

  const { map } = useLeaflet();

  useEffect(() => {
    mcg.clearLayers();
    if (polyline) {
      new L.PolylineClusterable(polyline.positions, {
        color: polyline.color,
      }).addTo(mcg);
    }
    for (var i = 0; i < templateStops.length; i++) {
      getTemplateStopMarkerAndAddToMcg(
        template,
        templateStops[i],
        templateStops[i].stopNumber,
        mcg,
        t
      );
    }
    map.addLayer(mcg);
    return function cleanup() {
      map.removeLayer(mcg);
    };
  }, [
    templateStops,
    polyline,
    getTemplateStopMarkerAndAddToMcg,
    template,
    t,
    mcg,
    map,
  ]);

  return null;
};

TemplateStopTemplateMarkerCluster.propTypes = {
  getClusterIcon: PropTypes.func.isRequired,
  getTemplateStopMarkerAndAddToMcg: PropTypes.func.isRequired,
  polyline: PropTypes.object,
  templateStops: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  template: PropTypes.object.isRequired,
  useCluster: PropTypes.bool.isRequired,
};

export default compose(withTranslation())(TemplateStopTemplateMarkerCluster);
